<template>
	<div class="change-form">
        <div slot="header" class="header">
            <h4>Change Email</h4>
        </div>
        <div class="change-section">
            <h5>New Email</h5>
            <!-- <el-input placeholder="Please input" v-model="newEmail" size="small">
            </el-input> -->
            <el-input placeholder="Please input" @focus="removeSameEmail" v-model="newEmail" size="small">
                <template v-if="changedEmail" slot="append">
                    <el-button type="success" @click="emailChange" size="small">
                        Change Email
                    </el-button>
                </template>
            </el-input>
            <div v-if="showValidation" class="validation">{{ validationText }}</div>
            <!-- <div class="change-buttons">
                <el-button @click="cancel" size="small">
                    Cancel
                </el-button>
                <el-button @click="emailChange" size="small">
                    Change
                </el-button>
            </div> -->
            <ChangeButtons @change="emailChange" @cancel="cancel" ></ChangeButtons>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import validateEmail from '../../util/valid-email'
import ChangeButtons from './ChangeButtons'

export default {
	name: 'change-email',
	data() {
		return {
            newEmail: null,
            showValidation: false,
            sameEmail: false
		}
    },
	watch: {
		newEmail(value) {
            if (validateEmail(value) == false)
                this.showValidation = true
            else
                this.showValidation = false
		}
	},
    mounted() {
        this.newEmail = this.user.email
    },
    methods: {
        emailChange() {
            if (this.newEmail == this.user.email) {
                this.sameEmail = true
                this.showValidation = true
            }
			this.$emit('change', {
				email: this.newEmail
			})
		},
		cancel() {
			this.$emit('cancel')
        },
        removeSameEmail() {
            this.sameEmail = false
            this.showValidation = false
        }
    },
	computed: {
		...mapState('user', [
			'user'
		]),
		changedEmail() {
			return (this.newEmail != this.user.email) && (! this.showValidation)
        },
        validationText() {
            if (this.sameEmail)
                return 'Cannot change to already existing email'
            else
                return 'Please correct invalid characters'
        }
    },
    components: {
        ChangeButtons
    }
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>